/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */

import React from 'react';
import PropTypes from "prop-types";
import { useCurrentEuiBreakpoint } from '../../services';
export var EuiShowFor = ({
  children,
  sizes
}) => {
  const currentBreakpoint = useCurrentEuiBreakpoint();
  const isWithinBreakpointSizes = currentBreakpoint && sizes.includes(currentBreakpoint);
  if (sizes === 'all' || isWithinBreakpointSizes) {
    return <>{children}</>;
  }
  return null;
};
EuiShowFor.propTypes = {
  /**
     * Required otherwise nothing ever gets returned
     */
  children: PropTypes.node.isRequired,
  /**
     * List of all the responsive sizes to show the children for.
     * Array of #EuiBreakpointSize
     */
  sizes: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.any.isRequired).isRequired, PropTypes.oneOf(["all", "none"])]).isRequired
};
try {
  EuiShowFor.__docgenInfo = {
    tags: {},
    filePath: '/app/src/components/responsive/show_for.tsx',
    description: '',
    displayName: 'EuiShowFor',
    methods: [],
    props: {
      children: {
        defaultValue: null,
        description: 'Required otherwise nothing ever gets returned',
        name: 'children',
        parent: {
          fileName: 'app/src/components/responsive/show_for.tsx',
          name: 'EuiShowForProps'
        },
        declarations: [{
          fileName: 'app/src/components/responsive/show_for.tsx',
          name: 'EuiShowForProps'
        }, {
          fileName: 'app/node_modules/@types/react/index.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ReactNode'
        }
      },
      sizes: {
        defaultValue: null,
        description: 'List of all the responsive sizes to show the children for.\n' + 'Array of #EuiBreakpointSize',
        name: 'sizes',
        parent: {
          fileName: 'app/src/components/responsive/show_for.tsx',
          name: 'EuiShowForProps'
        },
        declarations: [{
          fileName: 'app/src/components/responsive/show_for.tsx',
          name: 'EuiShowForProps'
        }],
        required: true,
        type: {
          name: 'string[] | "none" | "all"'
        }
      }
    },
    extendedInterfaces: ['EuiShowForProps']
  };
} catch (e) {}